/**
 * CartAddedItemContainer component
 * @returns <CartAddedItemContainer />
 */
import CartAddedItem from "./CartAddedItem"

const CartAddedItemContainer = ({ items, canEdit }) => {
    // console.log(items)
    return (
        <div className="cart__added-item__container">
            {items.map((item, i) => {
                {/* console.log(item) */ }
                return (
                    <CartAddedItem item={item} key={i} canEdit={canEdit} />
                )
            })}
        </div>
    )
}

export default CartAddedItemContainer